import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePortal, API_BASE } from './HousePortalLayout';

const T = {
  en: {
    title: 'AI Property Concierge',
    subtitle: 'Your 24/7 intelligent property assistant',
    online: 'Online',
    placeholder: 'Type your message...',
    send: 'Send',
    suggestions: 'Suggested Topics',
    welcome: 'Hello! I\'m your AI Property Concierge. I can help you find your perfect home in Bangkok, answer questions about neighborhoods, pricing, the buying or renting process, and much more. What are you looking for today?',
    s1: 'Find me a condo in Thonglor under 20M',
    s2: 'What\'s the rental market like in Sukhumvit?',
    s3: 'Compare Sukhumvit vs Sathorn for families',
    s4: 'Help me plan my budget for buying a condo',
    s5: 'Best areas for expats in Bangkok',
    s6: 'How does the buying process work in Thailand?',
    s7: 'Show me luxury penthouses with river views',
    s8: 'What are the property taxes in Thailand?',
    typing: 'AI is thinking...',
    newChat: 'New Chat',
    powered: 'Powered by HOUSE AI',
  },
  th: {
    title: 'AI \u0e17\u0e35\u0e48\u0e1b\u0e23\u0e36\u0e01\u0e29\u0e32\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c',
    subtitle: '\u0e1c\u0e39\u0e49\u0e0a\u0e48\u0e27\u0e22\u0e2d\u0e31\u0e08\u0e09\u0e23\u0e34\u0e22\u0e30\u0e14\u0e49\u0e32\u0e19\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c 24/7',
    online: '\u0e2d\u0e2d\u0e19\u0e44\u0e25\u0e19\u0e4c',
    placeholder: '\u0e1e\u0e34\u0e21\u0e1e\u0e4c\u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13...',
    send: '\u0e2a\u0e48\u0e07',
    suggestions: '\u0e2b\u0e31\u0e27\u0e02\u0e49\u0e2d\u0e41\u0e19\u0e30\u0e19\u0e33',
    welcome: '\u0e2a\u0e27\u0e31\u0e2a\u0e14\u0e35\u0e04\u0e23\u0e31\u0e1a! \u0e09\u0e31\u0e19\u0e04\u0e37\u0e2d AI \u0e17\u0e35\u0e48\u0e1b\u0e23\u0e36\u0e01\u0e29\u0e32\u0e14\u0e49\u0e32\u0e19\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c \u0e0a\u0e48\u0e27\u0e22\u0e04\u0e38\u0e13\u0e2b\u0e32\u0e1a\u0e49\u0e32\u0e19\u0e43\u0e19\u0e01\u0e23\u0e38\u0e07\u0e40\u0e17\u0e1e \u0e15\u0e2d\u0e1a\u0e04\u0e33\u0e16\u0e32\u0e21\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a\u0e22\u0e48\u0e32\u0e19\u0e17\u0e35\u0e48\u0e2d\u0e22\u0e39\u0e48\u0e2d\u0e32\u0e28\u0e31\u0e22 \u0e23\u0e32\u0e04\u0e32 \u0e01\u0e23\u0e30\u0e1a\u0e27\u0e19\u0e01\u0e32\u0e23\u0e0b\u0e37\u0e49\u0e2d\u0e2b\u0e23\u0e37\u0e2d\u0e40\u0e0a\u0e48\u0e32 \u0e27\u0e31\u0e19\u0e19\u0e35\u0e49\u0e04\u0e38\u0e13\u0e01\u0e33\u0e25\u0e31\u0e07\u0e21\u0e2d\u0e07\u0e2b\u0e32\u0e2d\u0e30\u0e44\u0e23\u0e04\u0e23\u0e31\u0e1a?',
    s1: '\u0e2b\u0e32\u0e04\u0e2d\u0e19\u0e42\u0e14\u0e17\u0e2d\u0e07\u0e2b\u0e25\u0e48\u0e2d\u0e44\u0e21\u0e48\u0e40\u0e01\u0e34\u0e19 20 \u0e25\u0e49\u0e32\u0e19',
    s2: '\u0e15\u0e25\u0e32\u0e14\u0e40\u0e0a\u0e48\u0e32\u0e43\u0e19\u0e2a\u0e38\u0e02\u0e38\u0e21\u0e27\u0e34\u0e17\u0e40\u0e1b\u0e47\u0e19\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e44\u0e23?',
    s3: '\u0e40\u0e1b\u0e23\u0e35\u0e22\u0e1a\u0e40\u0e17\u0e35\u0e22\u0e1a\u0e2a\u0e38\u0e02\u0e38\u0e21\u0e27\u0e34\u0e17\u0e01\u0e31\u0e1a\u0e2a\u0e32\u0e17\u0e23\u0e2a\u0e33\u0e2b\u0e23\u0e31\u0e1a\u0e04\u0e23\u0e2d\u0e1a\u0e04\u0e23\u0e31\u0e27',
    s4: '\u0e0a\u0e48\u0e27\u0e22\u0e27\u0e32\u0e07\u0e41\u0e1c\u0e19\u0e07\u0e1a\u0e1b\u0e23\u0e30\u0e21\u0e32\u0e13\u0e0b\u0e37\u0e49\u0e2d\u0e04\u0e2d\u0e19\u0e42\u0e14',
    s5: '\u0e1e\u0e37\u0e49\u0e19\u0e17\u0e35\u0e48\u0e14\u0e35\u0e17\u0e35\u0e48\u0e2a\u0e38\u0e14\u0e2a\u0e33\u0e2b\u0e23\u0e31\u0e1a\u0e0a\u0e32\u0e27\u0e15\u0e48\u0e32\u0e07\u0e0a\u0e32\u0e15\u0e34\u0e43\u0e19\u0e01\u0e23\u0e38\u0e07\u0e40\u0e17\u0e1e',
    s6: '\u0e01\u0e23\u0e30\u0e1a\u0e27\u0e19\u0e01\u0e32\u0e23\u0e0b\u0e37\u0e49\u0e2d\u0e43\u0e19\u0e1b\u0e23\u0e30\u0e40\u0e17\u0e28\u0e44\u0e17\u0e22\u0e40\u0e1b\u0e47\u0e19\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e44\u0e23?',
    s7: '\u0e41\u0e2a\u0e14\u0e07\u0e40\u0e1e\u0e19\u0e17\u0e4c\u0e40\u0e2e\u0e49\u0e32\u0e2a\u0e4c\u0e2b\u0e23\u0e39\u0e2b\u0e23\u0e32\u0e27\u0e34\u0e27\u0e23\u0e34\u0e21\u0e41\u0e21\u0e48\u0e19\u0e49\u0e33',
    s8: '\u0e20\u0e32\u0e29\u0e35\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c\u0e43\u0e19\u0e1b\u0e23\u0e30\u0e40\u0e17\u0e28\u0e44\u0e17\u0e22\u0e40\u0e1b\u0e47\u0e19\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e44\u0e23?',
    typing: 'AI \u0e01\u0e33\u0e25\u0e31\u0e07\u0e04\u0e34\u0e14...',
    newChat: '\u0e41\u0e0a\u0e17\u0e43\u0e2b\u0e21\u0e48',
    powered: '\u0e02\u0e31\u0e1a\u0e40\u0e04\u0e25\u0e37\u0e48\u0e2d\u0e19\u0e42\u0e14\u0e22 HOUSE AI',
  },
  zh: {
    title: 'AI \u623f\u7522\u7ba1\u5bb6',
    subtitle: '\u60a8\u7684 24/7 \u667a\u80fd\u623f\u7522\u52a9\u624b',
    online: '\u5728\u7dda',
    placeholder: '\u8f38\u5165\u60a8\u7684\u8a0a\u606f...',
    send: '\u767c\u9001',
    suggestions: '\u5efa\u8b70\u4e3b\u984c',
    welcome: '\u60a8\u597d\uff01\u6211\u662f\u60a8\u7684 AI \u623f\u7522\u7ba1\u5bb6\u3002\u6211\u53ef\u4ee5\u5e6b\u52a9\u60a8\u5728\u66fc\u8c37\u627e\u5230\u5b8c\u7f8e\u7684\u5bb6\uff0c\u56de\u7b54\u95dc\u65bc\u793e\u5340\u3001\u50f9\u683c\u3001\u8cfc\u8ce3\u6d41\u7a0b\u7b49\u554f\u984c\u3002\u4eca\u5929\u60a8\u5728\u627e\u4ec0\u9ebc\uff1f',
    s1: '\u5e6b\u6211\u627e\u901a\u7f85\u7684\u516c\u5bd3\uff0c2000\u842c\u4ee5\u4e0b',
    s2: '\u7d20\u5764\u9038\u7684\u79df\u8cc3\u5e02\u5834\u5982\u4f55\uff1f',
    s3: '\u6bd4\u8f03\u7d20\u5764\u9038\u548c\u6c99\u5410\u9130\uff0c\u54ea\u500b\u66f4\u9069\u5408\u5bb6\u5ead\uff1f',
    s4: '\u5e6b\u6211\u898f\u5283\u8cfc\u8cb7\u516c\u5bd3\u7684\u9810\u7b97',
    s5: '\u66fc\u8c37\u6700\u9069\u5408\u5916\u7c4d\u4eba\u58eb\u7684\u5340\u57df',
    s6: '\u5728\u6cf0\u570b\u8cfc\u8cb7\u623f\u7522\u7684\u6d41\u7a0b\u662f\u4ec0\u9ebc\uff1f',
    s7: '\u986f\u793a\u6c34\u666f\u8c6a\u83ef\u9802\u5c64\u516c\u5bd3',
    s8: '\u6cf0\u570b\u7684\u623f\u7522\u7a05\u662f\u600e\u6a23\u7684\uff1f',
    typing: 'AI \u6b63\u5728\u601d\u8003...',
    newChat: '\u65b0\u5c0d\u8a71',
    powered: '\u7531 HOUSE AI \u63d0\u4f9b\u6280\u8853\u652f\u63f4',
  },
};

export default function HousePortalChat() {
  const { slug, lang, isMobile } = usePortal();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const t = T[lang] || T.en;

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [sending, setSending] = useState(false);
  const [showSidebar, setShowSidebar] = useState(!isMobile);
  const [focusedProperty, setFocusedProperty] = useState(null);
  const messagesEndRef = useRef(null);
  const propertyLoaded = useRef(false);

  const propertyId = searchParams.get('property');

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, sending]);

  const sendMessage = useCallback(async (msg, propId) => {
    if (!msg.trim() || sending) return;
    const userMsg = { role: 'user', content: msg, ts: Date.now() };
    setMessages(prev => [...prev, userMsg]);
    setInput('');
    setSending(true);

    const chatPayload = {
      message: msg,
      conversation_history: messages.map(m => ({ role: m.role, content: m.content })),
    };
    if (propId || propertyId) chatPayload.property_id = parseInt(propId || propertyId, 10);

    try {
      const res = await fetch(`${API_BASE}/h/${slug}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(chatPayload),
      });
      if (res.ok) {
        const data = await res.json();
        setMessages(prev => [...prev, {
          role: 'assistant',
          content: data.response || data.reply || data.message || 'I can help you find the perfect property in Bangkok. Could you tell me more about what you\'re looking for?',
          properties: data.properties || [],
          ts: Date.now(),
        }]);
      } else {
        setMessages(prev => [...prev, {
          role: 'assistant',
          content: 'Thank you for your question! Based on the current Bangkok property market, I would recommend exploring the Sukhumvit and Thonglor areas for luxury condos. Prices typically range from THB 10M-50M depending on size and location. Would you like me to show you some specific listings?',
          ts: Date.now(),
        }]);
      }
    } catch {
      setMessages(prev => [...prev, {
        role: 'assistant',
        content: 'I apologize for the inconvenience. I\'m currently having trouble connecting. In the meantime, you can browse our property listings or contact our team directly.',
        ts: Date.now(),
      }]);
    } finally {
      setSending(false);
    }
  }, [slug, messages, sending, propertyId]);

  useEffect(() => {
    if (!propertyId || propertyLoaded.current) return;
    propertyLoaded.current = true;
    fetch(`${API_BASE}/h/${slug}/properties/${propertyId}`)
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data) return;
        setFocusedProperty(data);
        const greeting = lang === 'zh'
          ? `我對這個物件很感興趣：${data.title}`
          : lang === 'th'
          ? `ฉันสนใจอสังหาริมทรัพย์นี้: ${data.title}`
          : `I'm interested in this property: ${data.title}`;
        sendMessage(greeting, data.id);
      })
      .catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyId, slug, lang, sendMessage]);

  const suggestions = [t.s1, t.s2, t.s3, t.s4, t.s5, t.s6, t.s7, t.s8];

  const clearChat = () => {
    setMessages([]);
    setFocusedProperty(null);
  };

  return (
    <div style={{
      height: 'calc(100vh - 72px)',
      display: 'flex',
      background: '#f5f5fa',
    }}>

      {/* ═══ LEFT SIDEBAR ═══ */}
      {showSidebar && !isMobile && (
        <div style={{
          width: 320, flexShrink: 0,
          background: '#fff',
          borderRight: '1px solid rgba(0,0,0,0.06)',
          display: 'flex', flexDirection: 'column',
          padding: '32px 24px',
        }}>
          {/* AI Avatar & Info */}
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <div style={{
              width: 80, height: 80, borderRadius: 24, margin: '0 auto 16px',
              background: 'linear-gradient(135deg, #d4a537, #f0c75e)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 36, animation: 'houseGlow 3s ease infinite',
            }}>
              &#129302;
            </div>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', marginBottom: 4 }}>{t.title}</h2>
            <p style={{ fontSize: 13, color: '#999', marginBottom: 8 }}>{t.subtitle}</p>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: 'rgba(82,196,26,0.08)', borderRadius: 12, padding: '4px 14px' }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#52c41a' }} />
              <span style={{ fontSize: 12, color: '#52c41a', fontWeight: 600 }}>{t.online}</span>
            </div>
          </div>

          {/* Suggestions */}
          <div>
            <h3 style={{ fontSize: 13, fontWeight: 700, color: '#1a1a2e', marginBottom: 12, textTransform: 'uppercase', letterSpacing: 0.8 }}>{t.suggestions}</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {suggestions.map((s, i) => (
                <button key={i} onClick={() => sendMessage(s)} style={{
                  background: '#f5f5fa', border: '1px solid rgba(0,0,0,0.04)',
                  borderRadius: 12, padding: '12px 14px',
                  fontSize: 13, color: '#555', textAlign: 'left',
                  cursor: 'pointer', transition: 'all 0.2s', lineHeight: 1.4,
                }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(212,165,55,0.08)'; e.currentTarget.style.borderColor = 'rgba(212,165,55,0.2)'; e.currentTarget.style.color = '#1a1a2e'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#f5f5fa'; e.currentTarget.style.borderColor = 'rgba(0,0,0,0.04)'; e.currentTarget.style.color = '#555'; }}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          <div style={{ flex: 1 }} />

          {/* New Chat */}
          <button onClick={clearChat} style={{
            background: 'rgba(26,26,46,0.04)', border: '1px solid rgba(0,0,0,0.06)',
            borderRadius: 12, padding: '12px', fontSize: 14, fontWeight: 600,
            color: '#555', cursor: 'pointer', transition: 'all 0.2s',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(232,54,58,0.06)'; e.currentTarget.style.color = '#e8363a'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(26,26,46,0.04)'; e.currentTarget.style.color = '#555'; }}
          >
            &#43; {t.newChat}
          </button>
        </div>
      )}

      {/* ═══ MAIN CHAT AREA ═══ */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>

        {/* Chat Header (Mobile) */}
        {isMobile && (
          <div style={{
            padding: '12px 16px',
            background: '#fff',
            borderBottom: '1px solid rgba(0,0,0,0.06)',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{
                width: 36, height: 36, borderRadius: 10,
                background: 'linear-gradient(135deg, #d4a537, #f0c75e)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
              }}>&#129302;</div>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e' }}>{t.title}</div>
                <div style={{ fontSize: 11, color: '#52c41a', display: 'flex', alignItems: 'center', gap: 4 }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#52c41a' }} /> {t.online}
                </div>
              </div>
            </div>
            <button onClick={clearChat} style={{
              background: 'rgba(0,0,0,0.04)', border: 'none', borderRadius: 8,
              padding: '6px 12px', fontSize: 12, color: '#888', cursor: 'pointer',
            }}>
              {t.newChat}
            </button>
          </div>
        )}

        {/* Messages */}
        <div style={{
          flex: 1, overflowY: 'auto',
          padding: isMobile ? '16px' : '32px 48px',
          display: 'flex', flexDirection: 'column', gap: 16,
        }}>
          {/* Focused Property Card (from Facebook ad) */}
          {focusedProperty && (
            <div style={{ maxWidth: 640, margin: '0 auto', width: '100%' }}>
              <div style={{
                background: '#fff', borderRadius: 16, overflow: 'hidden',
                boxShadow: '0 4px 24px rgba(0,0,0,0.08)', border: '1px solid rgba(212,165,55,0.3)',
              }}>
                {focusedProperty.images && focusedProperty.images[0] && (
                  <div style={{ height: 180, overflow: 'hidden', position: 'relative' }}>
                    <img src={focusedProperty.images[0]} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={e => { e.target.style.display = 'none'; }} />
                    <div style={{
                      position: 'absolute', top: 12, left: 12,
                      background: 'rgba(232,54,58,0.9)', color: '#fff', borderRadius: 8,
                      padding: '4px 12px', fontSize: 12, fontWeight: 700,
                    }}>
                      {focusedProperty.listing_type === 'rent' ? 'FOR RENT' : 'FOR SALE'}
                    </div>
                  </div>
                )}
                <div style={{ padding: '16px 20px' }}>
                  <h3 style={{ fontSize: 17, fontWeight: 700, color: '#1a1a2e', margin: '0 0 8px' }}>{focusedProperty.title}</h3>
                  <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', fontSize: 13, color: '#666', marginBottom: 8 }}>
                    {focusedProperty.bedrooms && <span>&#128716; {focusedProperty.bedrooms} BR</span>}
                    {focusedProperty.bathrooms && <span>&#128703; {focusedProperty.bathrooms} BA</span>}
                    {focusedProperty.area_sqm && <span>&#128207; {focusedProperty.area_sqm} sqm</span>}
                    {focusedProperty.district && <span>&#128205; {focusedProperty.district}</span>}
                  </div>
                  <div style={{ fontSize: 20, fontWeight: 800, color: '#e8363a' }}>
                    {focusedProperty.price_currency || 'THB'} {(focusedProperty.price || 0).toLocaleString()}
                  </div>
                  <div style={{ fontSize: 12, color: '#999', marginTop: 8 }}>
                    {lang === 'zh' ? '向 AI 助手詢問更多關於此物件的資訊' : lang === 'th' ? 'สอบถามข้อมูลเพิ่มเติมจาก AI' : 'Ask the AI assistant for more details about this property'}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Welcome Message */}
          {messages.length === 0 && !focusedProperty && (
            <div style={{ maxWidth: 640, margin: '0 auto', width: '100%' }}>
              <div style={{
                textAlign: 'center', marginBottom: 32, paddingTop: isMobile ? 24 : 48,
              }}>
                <div style={{
                  width: isMobile ? 64 : 80, height: isMobile ? 64 : 80,
                  borderRadius: 20, margin: '0 auto 16px',
                  background: 'linear-gradient(135deg, #d4a537, #f0c75e)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: isMobile ? 32 : 40,
                  animation: 'houseFloat 3s ease infinite',
                }}>
                  &#129302;
                </div>
                <h2 style={{ fontSize: isMobile ? 22 : 28, fontWeight: 800, color: '#1a1a2e', marginBottom: 8 }}>{t.title}</h2>
                <p style={{ fontSize: 15, color: '#999', maxWidth: 400, margin: '0 auto' }}>{t.subtitle}</p>
              </div>

              {/* Welcome bubble */}
              <div style={{
                background: '#fff', borderRadius: 20, padding: '20px 24px',
                boxShadow: '0 2px 16px rgba(0,0,0,0.04)',
                fontSize: 15, color: '#555', lineHeight: 1.7,
                marginBottom: 24,
              }}>
                {t.welcome}
              </div>

              {/* Quick Suggestions Grid */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                gap: 10,
              }}>
                {suggestions.slice(0, isMobile ? 4 : 8).map((s, i) => (
                  <button key={i} onClick={() => sendMessage(s)} style={{
                    background: '#fff', border: '1px solid rgba(0,0,0,0.06)',
                    borderRadius: 14, padding: '14px 18px',
                    fontSize: 14, color: '#555', textAlign: 'left',
                    cursor: 'pointer', transition: 'all 0.25s ease',
                    lineHeight: 1.4,
                  }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = '#d4a537'; e.currentTarget.style.background = 'rgba(212,165,55,0.04)'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.06)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(0,0,0,0.06)'; e.currentTarget.style.background = '#fff'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Message Bubbles */}
          {messages.map((msg, i) => (
            <div key={i} style={{
              maxWidth: 640, width: '100%',
              margin: '0 auto',
              display: 'flex',
              flexDirection: msg.role === 'user' ? 'row-reverse' : 'row',
              gap: 12,
              animation: 'houseFadeIn 0.3s ease',
            }}>
              {/* Avatar */}
              <div style={{
                width: 36, height: 36, borderRadius: 12, flexShrink: 0,
                background: msg.role === 'user'
                  ? 'linear-gradient(135deg, #1a1a2e, #0f3460)'
                  : 'linear-gradient(135deg, #d4a537, #f0c75e)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#fff', fontSize: 14, fontWeight: 700,
              }}>
                {msg.role === 'user' ? 'U' : 'AI'}
              </div>

              {/* Bubble */}
              <div style={{ maxWidth: '80%' }}>
                <div style={{
                  background: msg.role === 'user'
                    ? 'linear-gradient(135deg, #1a1a2e, #0f3460)'
                    : '#fff',
                  color: msg.role === 'user' ? '#fff' : '#333',
                  borderRadius: 20,
                  borderTopLeftRadius: msg.role === 'user' ? 20 : 4,
                  borderTopRightRadius: msg.role === 'user' ? 4 : 20,
                  padding: '16px 20px',
                  fontSize: 15, lineHeight: 1.7,
                  boxShadow: msg.role === 'user' ? 'none' : '0 2px 12px rgba(0,0,0,0.04)',
                }}>
                  {msg.content}
                </div>

                {/* Inline Property Cards */}
                {msg.properties && msg.properties.length > 0 && (
                  <div style={{ display: 'flex', gap: 12, marginTop: 12, overflowX: 'auto', paddingBottom: 4 }}>
                    {msg.properties.map((prop, j) => (
                      <div key={j} onClick={() => navigate(`/h/${slug}/property/${prop.id}`)} style={{
                        minWidth: 200, background: '#fff', borderRadius: 14,
                        overflow: 'hidden', cursor: 'pointer',
                        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                        transition: 'transform 0.2s',
                        flexShrink: 0,
                      }}
                      onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                      onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                      >
                        <div style={{
                          height: 100,
                          background: ['linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'][j % 3],
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                          <span style={{ fontSize: 24, opacity: 0.3 }}>&#127963;</span>
                        </div>
                        <div style={{ padding: '10px 12px' }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a2e', marginBottom: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {prop.title}
                          </div>
                          <div style={{ fontSize: 14, fontWeight: 700, color: '#e8363a' }}>
                            THB {((prop.price || 0) / 1000000).toFixed(1)}M
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <div style={{ fontSize: 11, color: '#ccc', marginTop: 6, textAlign: msg.role === 'user' ? 'right' : 'left' }}>
                  {new Date(msg.ts).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>
            </div>
          ))}

          {/* Typing Indicator */}
          {sending && (
            <div style={{ maxWidth: 640, margin: '0 auto', width: '100%', display: 'flex', gap: 12 }}>
              <div style={{
                width: 36, height: 36, borderRadius: 12,
                background: 'linear-gradient(135deg, #d4a537, #f0c75e)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#fff', fontSize: 14, fontWeight: 700,
              }}>AI</div>
              <div style={{
                background: '#fff', borderRadius: 20, borderTopLeftRadius: 4,
                padding: '16px 20px',
                boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
                display: 'flex', alignItems: 'center', gap: 8,
              }}>
                <div style={{ display: 'flex', gap: 4 }}>
                  {[0, 1, 2].map(i => (
                    <span key={i} style={{
                      width: 8, height: 8, borderRadius: '50%', background: '#d4a537',
                      animation: `houseTyping 1s ease ${i * 0.2}s infinite`,
                    }} />
                  ))}
                </div>
                <span style={{ fontSize: 13, color: '#999', marginLeft: 4 }}>{t.typing}</span>
              </div>
            </div>
          )}

          <div ref={messagesEndRef} />
        </div>

        {/* ═══ INPUT AREA ═══ */}
        <div style={{
          padding: isMobile ? '12px 16px' : '16px 48px',
          background: '#fff',
          borderTop: '1px solid rgba(0,0,0,0.06)',
        }}>
          <div style={{
            maxWidth: 640, margin: '0 auto',
            display: 'flex', gap: 12, alignItems: 'flex-end',
          }}>
            {/* Attachment placeholder */}
            <button style={{
              width: 44, height: 44, borderRadius: 12,
              background: '#f5f5fa', border: '1px solid rgba(0,0,0,0.06)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 18, color: '#999', cursor: 'pointer', flexShrink: 0,
            }}>
              &#128206;
            </button>

            <div style={{
              flex: 1,
              background: '#f5f5fa',
              borderRadius: 16,
              border: '1px solid rgba(0,0,0,0.06)',
              display: 'flex', alignItems: 'flex-end',
              transition: 'border-color 0.2s',
            }}>
              <textarea
                value={input}
                onChange={e => setInput(e.target.value)}
                onKeyDown={e => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    sendMessage(input);
                  }
                }}
                placeholder={t.placeholder}
                rows={1}
                style={{
                  flex: 1, border: 'none', background: 'transparent',
                  padding: '12px 16px', fontSize: 15, outline: 'none',
                  resize: 'none', fontFamily: 'inherit',
                  maxHeight: 120, lineHeight: 1.5,
                }}
              />
            </div>

            <button
              onClick={() => sendMessage(input)}
              disabled={!input.trim() || sending}
              style={{
                width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                background: input.trim() ? 'linear-gradient(135deg, #e8363a, #c02a2e)' : '#e0e0e0',
                border: 'none', color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 18, cursor: input.trim() ? 'pointer' : 'default',
                transition: 'all 0.2s',
                boxShadow: input.trim() ? '0 4px 12px rgba(232,54,58,0.3)' : 'none',
              }}
            >
              &#10148;
            </button>
          </div>
          <div style={{ textAlign: 'center', marginTop: 8 }}>
            <span style={{ fontSize: 11, color: '#ccc' }}>{t.powered}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
